// extracted by mini-css-extract-plugin
export var divider = "techStack-module--divider--D874u";
export var title = "techStack-module--title--DUmmo";
export var desc = "techStack-module--desc--7uh4G";
export var row = "techStack-module--row--Pqngf";
export var btn = "techStack-module--btn--yRNDR";